export function createMarketplace(market, allMarkets) {
  return {
    marketplaceCode: market.marketplace,
    markets: Object.values(allMarkets).filter((m) => {
      return m.marketplace === market.marketplace;
    })
  };
}
